import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { ISkuCategory } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class SkuCategoryService extends BaseService<ISkuCategory> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'skuCategory');
  }
}

export { ISkuCategory } from '../shared/api';
